module.exports = __webpack_public_path__ + "img/back.0bbe49d6.svg";